class scrollHelper{
	constructor() {
		this.bindScrollToTop();
		//this.bindAnimatedScroll();
	}
	bindScrollToTop() {
		$('[data-scroll-top]').on('click', function(e) {
			e.preventDefault();
			$("html, body").animate({ scrollTop: 0 }, "slow");
		});
	}
	bindAnimatedScroll() {
		if(window.location.hash) {
			$('html, body').animate({
				scrollTop: $(window.location.hash).offset().top - 146
			}, 500);
		}
	}
}
window.app.add('scroll', new scrollHelper());